/**
 * Rhythmic Motif Definition
 */
export interface RhythmicMotif {
    // Array of durations in seconds (or relative units if we normalize)
    // We will use "Beat Units" where 1.0 = Quarter Note, 0.5 = Eighth Note
    pattern: number[];
}

/**
 * Quantize a raw duration (in seconds) to the nearest musical grid unit.
 * @param durationSeconds 
 * @param bpm Used to convert seconds to beats
 */
export function quantizeToGrid(durationSeconds: number, bpm: number | null): number {
    const effectiveBPM = bpm || 120;
    const beatDuration = 60 / effectiveBPM;

    // Calculate duration in beats
    const beats = durationSeconds / beatDuration;

    // Grid: 0.25 (16th), 0.5 (8th), 0.75 (dotted 8th), 1.0 (quarter), 1.5, 2.0
    const grid = [0.25, 0.5, 0.75, 1.0, 1.5, 2.0, 3.0, 4.0];

    let closest = grid[0];
    let minDiff = Infinity;

    for (const val of grid) {
        const diff = Math.abs(beats - val);
        if (diff < minDiff) {
            minDiff = diff;
            closest = val;
        }
    }

    return closest;
}
